module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_co_cats_art_ec48c0668817f675fa367380aa7f8111.png";